import React from 'react';
import GeckoTableCellBase from '../_base.jsx';
import { GeckoStatus } from '../../../../';

class GeckoTableCellStatus extends GeckoTableCellBase {
  renderStyle() {
    let styleObj;

    if (this.cell().styles) {
      styleObj = this.cell().styles.find((style) => {
        return style.key === this.renderValue();
      });
    }

    return styleObj || false;
  }

  render() {
    if (!this.renderStyle()) return null;
    return (
      <div>
        <GeckoStatus
          name={this.renderStyle().name}
          type={this.renderStyle().type}
          tooltip={
            this.cell().tooltip !== undefined ? this.cell().tooltip : true
          }
        />
      </div>
    );
  }
}

export default GeckoTableCellStatus;
